var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{attrs:{"size":"small"},on:{"input":_vm.input},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},_vm._l((_vm.listData),function(item,index){return _c('el-radio-button',{key:index,attrs:{"label":item.keyId}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }